<div *ngIf="group" [formGroup]="group" class="form-group">
  <label>{{ label }}</label>
  <div *ngFor="let item of items" class="form-check">
    <input type="checkbox" [id]="item.domId" [formControlName]="item.formControlName" class="form-check-input" />
    <label [for]="item.domId" class="form-check-label fw-normal">{{ item.label }}</label>
  </div>
</div>
